import React, { useState } from "react";
// import faqData from "./faqData.json"; // Import JSON data (or you can define it inside the component)

let faqData = [
  {
    "number": "01",
    "title": "Cutting-Edge Technology",
    "text": "We stay ahead of the curve by leveraging the latest technologies, frameworks, and tools, ensuring that our solutions are scalable, secure, and high-performing."
  },
  {
    "number": "02",
    "title": "Tailored Solutions for Every Business",
    "text": "We understand that every business has unique needs. That’s why we offer customized IT solutions that align perfectly with your goals, whether you’re a startup or an enterprise."
  },
  {
    "number": "03",
    "title": "Agile Development & Rapid Delivery",
    "text": "We follow Agile methodologies to ensure flexibility, faster time-to-market, and continuous improvements, helping businesses adapt to changing market demands."
  },
  {
    "number": "04",
    "title": "Scalable & Future-Proof Applications",
    "text": "Our solutions are built with scalability in mind, allowing your business to expand effortlessly as it grows. We use modular architectures to accommodate future enhancements."
  },
  {
    "number": "05",
    "title": "Seamless User Experience (UX/UI)",
    "text": "We prioritize intuitive designs and seamless user experiences, ensuring that your website, mobile app, or software is both visually appealing and easy to use."
  },
  {
    "number": "06",
    "title": "Secure & Reliable Solutions",
    "text": "Security is at the core of everything we build. We follow best security practices to protect your business from cyber threats, data breaches, and vulnerabilities."
  },
  {
    "number": "07",
    "title": "End-to-End IT Services",
    "text": "From concept to deployment, we provide full-cycle development services, including consultation, design, development, testing, and post-launch support."
  },
  {
    "number": "08",
    "title": "Dedicated Support & Maintenance",
    "text": "We don’t just deliver and disappear. Our dedicated support team ensures your applications run smoothly with regular updates, troubleshooting, and performance optimization."
  }
];


const Choose = () => {
  
  const [activeIndex, setActiveIndex] = useState(0);
  const [ismore , setISMore] = useState(false);

  const handleMoreTogle =()=>{
      setISMore(!ismore);

  }

  // Toggle function
  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="why-us" className="section why-us light-background" data-builder="section">
      <div className="container-fluid">
        <div className="row gy-4">
          {/* Left Side Content */}
          <div className="col-lg-7 d-flex flex-column justify-content-center order-2 order-lg-1">
            <div className="content px-xl-5">
              <h3>
                <span>Why Choose </span>
                <strong>TechBiz <span className="sitename-1">SoftwareSolutions</span>?</strong>
              </h3>
              <p>
                At TechBiz <span className="sitename-2">SoftwareSolutions</span>, we specialize in custom software development, mobile applications, and website design that help businesses stay ahead in a competitive digital landscape.
              </p>
            </div>

            {/* FAQ Section */}
            <div className="faq-container px-xl-5">
              {faqData.map((item, index) => (
                <div
                  className={`faq-item ${activeIndex === index ? "faq-active" : ""}`}
                  key={index}
                  onClick={() => handleToggle(index)}
                  style={ ismore ? {} :{display : index >= 4 ? 'none' :'block'}}
                >
                  <h3>
                    <span>{item.number}</span> {item.title}
                  </h3>
                  <div className="faq-content" style={{ display: activeIndex === index ? "block" : "none" }}>
                    <p>{item.text}</p>
                  </div>
                  <i className={`faq-toggle bi ${activeIndex === index ? "bi-chevron-down" : "bi-chevron-right"}`}></i>
                </div>
              ))}
            </div>
            <a  className="text-end px-5 container" onClick={handleMoreTogle} style={{cursor:"pointer"}}>{ismore ? 'Show Less' : 'Show More'}</a>
          </div>

          {/* Right Side Image */}
          <div className="col-lg-5 order-1 order-lg-2 why-us-img">
            <img src="assets/img/why-us.png" className="img-fluid" alt="Why Us" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Choose;
